export default __webpack_public_path__ + "static/media/Boots of Infernal Zeal.2eee9343.jpg";